/**
* @ngdoc directive
* @name Date Selector
*
* @description
  Shows single date selector in input
*
* @scope
* @param {Moment/String} date -
* @param {String} dateFormat - optional format used to display date in input
* @param {Function} callback - optional callback on date change
* @param {Moment/String} minDate - optional
* @param {Moment/String} maxDate - optional
* @param {String} placeholder - optional
* @param {Boolean} isHideIcon - optional hide calendar icon
* @param {Boolean} isAddControl - optional add 'add-control' class
* @param {Boolean} isRequired - optional
* @param {Boolean} isDisabled - optional
* @param {Boolean} isFullWidth - optional make input full width
* @param {Array} availableDates - optional moment dates available to select
* @param {String} name - optional input name
* @param {Array} daysOfWeekDisabled - optional arrray of disabled days [1,2,3,4,5,6]
* @param {Boolean} isNotTabbable - optional pass on tab
*
* @example
  <date-selector
    ng-init='date="2017-01-15"'
    name="date"
    date="date"
    placeholder="Date"
    days-of-week-disabled="[0,1,2]"
    is-required=true
    max-date='"2018-01-20"'
    min-date='"2017-01-10"'>
  </date-selector>
*/

(function() {
  'use strict';

  directive.$inject = ["PATH", "$document", "$timeout"];
  app.directive('dateSelector', directive);

  function directive(PATH, $document, $timeout) {
    controller.$inject = ["$scope", "screenSizeService"];
    return {
      restrict: 'E',
      templateUrl: PATH.components + 'dateSelector/template.html',
      scope: {
        date: '=?',
        dateFormat: '@?',
        callback: '&',
        minDate: '=?',
        maxDate: '=?',
        placeholder: '@?',
        isHideIcon: '=?',
        isAddControl: '=?',
        isRequired: '=?',
        isDisabled: '=?',
        isFullWidth: '=?',
        availableDates: '=?',
        name: '@?',
        daysOfWeekDisabled: '@?',
        isNotTabbable: '@?',
        startView: '@?',
        placement: '@?',
        isCalendarInput: '@?',
        validation: '@?',
        selector: '@?'
      },
      controller: controller,
      link: link
    };

    function link(scope, $element) {
      scope.$watch('date', function (newValue) {
        if (!newValue) { // && scope.isRequired) {
          scope.date = moment().startOf('day');
        }

        if (scope.validation) {
          $timeout(function() {
            if (scope.selector) {
              angular.element(scope.selector).triggerHandler('click');
            } else {
              $document.triggerHandler('click');
            }
            scope.callback({ date: moment(scope.date) });
          });
        } else {
          scope.callback({ date: moment(scope.date) });
        }
      });

      scope.$watch('availableDates', function (newValue, oldValue) {
        if (!oldValue && newValue) {
          scope.opts.availableDates = newValue;
        }
      });

      if (scope.isNotTabbable) {
        $element.find('input').attr('tabindex', -1);
      }
    }

    function controller($scope, screenSizeService) {

      $scope.isValid = function () {
        if (moment($scope.date).diff($scope.maxDate) > 0) {
          return false;
        } else {
          return moment.isMoment($scope.date) && $scope.date.isValid();
        }
        // !$scope.isRequired && !$scope.date || moment.isMoment($scope.date) && $scope.date.isValid();
      };

      $scope.isInvalidDate = function (date) {
        var result = false;
        // if (!$scope.isRequired && !date) {
        //   return false;
        // }

        if ($scope.daysOfWeekDisabled) {
          result = $scope.daysOfWeekDisabled.indexOf(date.day()) >= 0;
        }

        if ($scope.availableDates) {
          var dates = _.filter($scope.availableDates, function (availableDate) {
            return availableDate.diff(date, 'days') === 0;
          });

          result = dates.length === 0;
        }

        return result;
      };

      $scope.init = function () {
        $scope.date = $scope.date || moment();  // $scope.isRequired && moment();
        $scope.dateFormat = $scope.dateFormat || 'MM/DD/YYYY';
        $scope.placeholder = $scope.placeholder || '';
        $scope.name = $scope.name || 'dateSelector';
        $scope.dateSelectorId = 'dateSelector_' + Math.floor((Math.random() * 1000) + 1);

        $scope.opts = {
          isMobile: screenSizeService.smallerThan('md'),
          screenMode: screenSizeService.screenMode(),
          singleDatePicker: true,
          availableDates: $scope.availableDates,
          isInvalidDate: $scope.isInvalidDate,
          startView: +$scope.startView,
          placement: $scope.placement,
          parentEl: screenSizeService.smallerThan('md') ? undefined : '#' + $scope.dateSelectorId,
          locale: {
            format: $scope.dateFormat
          },
          eventHandlers: {
            'cancel.daterangepicker': function () {
              $scope.callback();
            },
            'apply.daterangepicker': function () {
              $scope.callback({ date: $scope.date });
            }
          }
        };

        $scope.opts.autoApply = $scope.opts.isMobile;
      };

      $scope.init();
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/dateSelector/directive.js